import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
// import Footer from './Footer/Footer';
import Dashboard from '../Pages/Dashboard/Dashboard';
import { Users } from '../Pages/Users/Users';
import { Videos } from '../Pages/Videos/Videos';
import { Reports } from '../Pages/Reports/Reports';

import { useDispatch, useSelector } from 'react-redux';
import { setToggleSideBar } from '../store/UserSlices/ToggleSideBar';
import PrivateRoute from '../PrivateRoute/PrivateRoute'; // Import PrivateRoute
import Login from '../Pages/Login/Login';
import { Signup } from '../Pages/Signup/Signup';
import { ForgetPassword } from '../Pages/ForgetPassword/ForgetPassword';
import { ResetPassword } from '../Pages/ResetPassword/Resetpassword';
import { UserReports } from '../Pages/UserReports/UserReports';
import { useEffect } from 'react';

const Layout = () => {
  const dispatch = useDispatch();
  const { toggleSideBar } = useSelector((state) => state.toggleSideBar);
  const { darkMode } = useSelector((state) => state.darkMode);
  const location = useLocation();

  // Close sidebar on route change
  useEffect(() => {
    if (toggleSideBar) {
      dispatch(setToggleSideBar()); 
    }
  }, [location.pathname, dispatch]);

  const handleToggle = () => {
    dispatch(setToggleSideBar());
  };

  const authToken = localStorage.getItem('authToken');

  // Check if the current path is one of the auth routes
  const isAuthRoute = ['/login', '/register', '/forget-password', '/reset-password'].includes(location.pathname);

  return (
    <div className={`relative min-h-screen w-full ${darkMode ? 'dark' : ''}`}>
      <div
        className={`fixed inset-0 z-40 bg-gray-900 bg-opacity-50 transition-opacity duration-300 
          ${toggleSideBar && !isAuthRoute ? "opacity-10 bg-white" : "pointer-events-none opacity-0"}`}
        onClick={handleToggle}
      />
      {authToken && <Header />}
      {authToken && <Sidebar />}
      <main className={`p-4 bg-white text-black dark:bg-gray-900 dark:text-white`}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Signup />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<PrivateRoute Component={Dashboard} />} />
          <Route path="/users" element={<PrivateRoute Component={Users} />} />
          <Route path="/videos" element={<PrivateRoute Component={Videos} />} />
          <Route path="/reports" element={<PrivateRoute Component={Reports} />} />
          <Route path="/user-reports" element={<PrivateRoute Component={UserReports} />} />
        </Routes>
      </main>
      {/* {authToken && <Footer />}*/}
    </div>
  );
};

export default Layout;